<template>
  <div>
    <div class="customer-case">
      <div class="item">
        <div class="img">
          <img :src="krspace" alt="">
        </div>
        
        <div class="text-box">
          <h1>氪空间 | 高端联合办公 全城商圈任你选</h1>
          <p>氪空间是高端办公空间业界领军者，致力于成为联合办公行业中的龙头企业。氪空间通过NOVOIOT智能门禁，会议室管理系统帮助全国各地不同社区的不同会员管理其员工。</p>
        </div>
      </div>
      <div class="item">
        <div class="img">
          <img  :src="kr" alt="">
        </div>
        
        <div class="text-box">
          <h1>36kr | 专心做有价值的商业媒体</h1>
          <p>36氪，是一家专心做有价值的商业媒体，覆盖科技，创业投资，政策解读，行业预测等多种资讯，是中国领先的科技新媒体。NOVOIOT为36kr提供一站式办公解决方案，实现了设备、空间的自动化管理。</p>
        </div>
      </div>
    </div>
    <NovoGotop/>
    <NovoFooter/>
  </div>
</template>
<script>
// import NovoFooter from "novo-ui/novo-footer";
// NovoGotop
import { NovoGotop, NovoFooter } from "novo-ui";
export default {
  components: {
    NovoFooter,
    NovoGotop
  },
  data(){
    return {
      kr: require("common/image/home/customer/36kr@2x.png"),
      novoiot: require("common/image/home/customer/novoiot@2x.png"),
      krspace: require("common/image/home/customer/krspace@2x.png"),
    }
  }
};
</script>
<style scoped lang="scss" >
.customer-case {
  width: 980px;
  padding-top: 100px;
  margin: auto;
  .item {
    vertical-align: middle;
    width: 100%;
    margin: 26px 0px;
    .img {
      float: left;
      width: 280px;
      height: 180px;
      display: inline-block;
      border-radius: 6px;
      border: 1px solid #3ca9ff;
      position: relative;
      img{
        // display: block;
        // width: 126px;
        // height: 67px;
        position: absolute;
        max-width: 80%;
        max-height: 50%;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
      }
    }
    .text-box {
      display: inline-block;
      width: 628px;
      height: 180px;
      // background: red;
      padding-left: 20px;
      h1 {
        font-size: 20px;
        color: #000000;
      }
      p {
        margin-top: 10px;
        font-size: 18px;
        color: #000000;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/customer-case/index.vue